import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EmployeeListRoute } from 'src/components/AppRoutes/EmployeeRoutes.layout';
import { buildCAUIUrl, CAUIPage } from 'src/constants/urls';
import { useEmployeeListFeatureAccess } from 'src/components/enterprise/features/Employee/Routes/useEmployeeListFeatureAccess/useEmployeeListFeatureAccess';
import { getWindow } from 'src/utilities/window';

export function EmployeeListAccessGate(): JSX.Element | null {
  const { corpid: corpId } = useParams<{ corpid: string }>();
  const { canAccessEmployeeList, isLoading } = useEmployeeListFeatureAccess();

  useEffect(() => {
    if (isLoading || canAccessEmployeeList) {
      return;
    }

    const cauiRedirectUrl = buildCAUIUrl(CAUIPage.EMPLOYEES, {
      corpId,
    });

    const window = getWindow();
    window.location.href = cauiRedirectUrl;
  }, [canAccessEmployeeList, corpId, isLoading]);

  if (isLoading || !canAccessEmployeeList) {
    return null;
  }

  return <EmployeeListRoute />;
}
